import React, { useState, useEffect } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Badge,
} from "reactstrap";
import PublicOrderingServices from "../services/PublicOrderingServices"; // your service
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import StatusBadge from "../../../Components/Common/Badge";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import ConfirmModal from "./ConfirmModal";
import playBeep from "./PlayBeep";
const OrderTracking = ({ isOpen, toggle, orgData }) => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  console.log("🚀 ~ OrderTracking ~ selectedOrder:", selectedOrder);
  const [orders, setOrders] = useState([]);
  const [rawData, setRawData] = useState([]);
  console.log("🚀 ~ OrderTracking ~ orders:", orders);
  const [loading, setLoading] = useState(false);
  const orgcode = orgData?.orgCode;
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [orderToCancel, setOrderToCancel] = useState(null);

  const customerInfo = JSON.parse(localStorage.getItem("CustomerInfo") || "{}");
  const isLoggedIn = !!customerInfo?.accessToken;
  const navigate = useNavigate();

  useEffect(() => {
    if (isOpen && isLoggedIn) {
      fetchCustomerOrders();
    }
  }, [isOpen]);

  const fetchCustomerOrders = async () => {
    setLoading(true);
    try {
      const response = await PublicOrderingServices.getCustomerOrders({
        token: customerInfo.accessToken,
        apikey: orgcode,
        pageNumber: 1,
        pageSize: 20,
      });

      console.log("🚀 ~ fetchCustomerOrders (new API) ~ response:", response);

      setRawData(response);

      const formattedOrders = (response.items || []).map((order) => ({
        orderId: order.orderRefrenceId || `ORD-${order.id}`,
        status: order.orderStatus || order.paymentStatus || "Pending",
        totalAmount: order.grandTotal || order.totalAmount || 0,
        placedTime: order.createdAt || new Date().toISOString(),
        customer: {
          name: customerInfo?.userName,
          phoneNumber: customerInfo?.user?.phoneNumber,
        },
        // ❗ Order details not included in list API → keep empty
        items: [],
        specialInstructions: order.remarks || "",
      }));

      setOrders(formattedOrders);
    } catch (err) {
      console.error("Error fetching customer orders:", err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };
  // const cancelOrder = async (orderId) => {
  //   if (!window.confirm("Are you sure you want to cancel this order?")) return;

  //   setLoading(true);

  //   try {
  //     await PublicOrderingServices.updateCustomerOrderStatus({
  //       orderRefNumber: orderId,
  //       status: 3, // CANCELLED
  //       apikey: orgcode,
  //       token: customerInfo.accessToken,
  //     });

  //     toast.success("Order cancelled successfully!");

  //     fetchCustomerOrders();
  //     setSelectedOrder(null);
  //   } catch (error) {
  //     console.error("Cancel order error:", error);
  //     toast.error("Unable to cancel order.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleCancelClick = (order) => {
    setOrderToCancel(order);
    setCancelModalVisible(true);
  };

  const confirmCancelOrder = async () => {
    if (!orderToCancel) return;

    setLoading(true);
    try {
      await PublicOrderingServices.updateCustomerOrderStatus({
        orderRefNumber: orderToCancel.orderId,
        status: 3, // CANCELLED
        apikey: orgcode,
        token: customerInfo.accessToken,
      });

      toast.success("Order cancelled successfully!");
      fetchCustomerOrders();
      setSelectedOrder(null);
    } catch (error) {
      console.error("Cancel order error:", error);
      toast.error("Unable to cancel order.");
    } finally {
      setLoading(false);
      setCancelModalVisible(false);
      setOrderToCancel(null);
    }
  };
  const viewOrderDetail = async (order) => {
    setLoading(true);
    try {
      const detail = await PublicOrderingServices.getCustomerOrderDetail({
        token: customerInfo.accessToken,
        apikey: orgcode,
        orderRefNumber: order.orderId,
      });

      // Map order details to your UI structure
      const formattedOrder = {
        orderId: detail.orderRefrenceId || `ORD-${detail.id}`,
        status: detail.orderStatus || detail.paymentStatus || "Pending",
        totalAmount: detail.grandTotal || detail.totalAmount || 0,
        placedTime: detail.orderDate || new Date().toISOString(),
        customer: {
          name: customerInfo?.userName,
          phoneNumber: customerInfo?.user?.phoneNumber,
        },
        items: (detail.orderDetails || []).map((item) => ({
          id: item.id,
          name: item.productName,
          qty: item.finalQuantity || item.quantity,
          price: item.productPrice,
        })),
        specialInstructions: detail.remarks || "",
      };

      setSelectedOrder(formattedOrder);
    } catch (err) {
      console.error("Error fetching order detail:", err);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    console.log("🚀 ~ getStatusColor ~ status:", status);
    const s = status?.toString().trim().toLowerCase();

    switch (s) {
      case "1":
      case "ongoing":
        return "#ff9800"; // orange

      case "4":
      case "preparing":
        return "#17a2b8"; // teal/blue

      case "2":
      case "completed":
        return "#28a745"; // green

      case "3":
      case "cancelled":
        return "#dc3545"; // red

      default:
        return "#6c757d"; // gray
    }
  };

  const getStatusIcon = (status) => {
    const s = status?.toString().toLowerCase();

    switch (s) {
      case "1":
      case "ongoing":
        return "bx-loader-circle bx-spin";

      case "4":
      case "preparing":
        return "bx-time-five";

      case "2":
      case "completed":
        return "bx-check-double";

      case "3":
      case "cancelled":
        return "bx-x-circle";

      default:
        return "bx-question-mark";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", { hour12: true });
  };

  return (
    <>
      <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
        <OffcanvasHeader toggle={toggle}>
          <div className="d-flex align-items-center gap-2">
            <i
              className="bx bx-receipt"
              style={{ fontSize: "24px", color: "#ff7900" }}
            />
            <span>My Orders</span>
          </div>
        </OffcanvasHeader>
        <OffcanvasBody>
          {!selectedOrder ? (
            <>
              {!isLoggedIn && (
                <div className="text-center py-5">
                  <i
                    className="bx bx-lock-alt"
                    style={{ fontSize: "64px", color: "#ccc" }}
                  />
                  <p className="text-muted mt-3">Please login to view orders</p>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => {
                      playBeep();
                      window.location.href = `/${orgcode}/customer-login`;
                    }}
                  >
                    Login Now
                  </Button>
                </div>
              )}

              {isLoggedIn && loading && (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-3 text-muted">Loading your orders...</p>
                </div>
              )}

              {isLoggedIn && !loading && orders.length === 0 && (
                <div className="text-center py-5">
                  <i
                    className="bx bx-cart"
                    style={{ fontSize: "64px", color: "#ccc" }}
                  />
                  <p className="text-muted mt-3">No orders yet</p>
                </div>
              )}

              {isLoggedIn && !loading && orders.length > 0 && (
                <>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Order History ({orders.length})</h6>
                    <Button
                      color="link"
                      size="sm"
                      onClick={() => {
                        playBeep();
                        fetchCustomerOrders();
                      }}
                      className="text-primary"
                    >
                      <i className="bx bx-refresh" /> Refresh
                    </Button>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {orders.map((order) => {
                      console.log("🚀 ~ OrderTracking ~ order:", order);
                      return (
                        <div
                          key={order.orderId}
                          className="order-card"
                          onClick={() => {
                            playBeep();
                            viewOrderDetail(order);
                          }}
                          style={{
                            backgroundColor: "white",
                            borderRadius: "12px",
                            padding: "16px",
                            cursor: "pointer",
                            border: "1px solid #e5e7eb",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 4px 12px rgba(0,0,0,0.15)";
                            e.currentTarget.style.transform =
                              "translateY(-2px)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.boxShadow =
                              "0 1px 3px rgba(0,0,0,0.1)";
                            e.currentTarget.style.transform = "translateY(0)";
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <strong
                                style={{ fontSize: "14px", color: "#1f2937" }}
                              >
                                {order.orderId}
                              </strong>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  marginTop: "4px",
                                }}
                              >
                                <i className="bx bx-time-five" />{" "}
                                {formatDate(order.placedTime)}
                              </div>
                            </div>
                            {/* <Badge
                            style={{
                              backgroundColor: getStatusColor(order.status),
                              fontSize: "11px",
                              padding: "4px 8px",
                              color: "white",
                              border: "none",
                            }}
                          >
                            <i
                              className={`bx ${getStatusIcon(
                                order.status
                              )} me-1`}
                            />
                            {order.status}
                          </Badge> */}

                            <StatusBadge
                              status={order.status}
                              type="order"
                              pill="true"
                            />
                          </div>
                          <div className="d-flex justify-content-between align-items-center">
                            {/* <div style={{ fontSize: "12px", color: "#666" }}>
                            <i className="bx bx-dish" /> {order.items.length}{" "}
                            items
                          </div> */}
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#ff7900",
                              }}
                            >
                              Rs.{" "}
                              <NumberWithCommas number={order.totalAmount} />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <>
                {/* Order Details */}
                <div
                  className="d-flex align-items-left"
                  style={{ height: "40px" }} // set desired height
                >
                  <Button
                    color="link"
                    onClick={() => {
                      playBeep();
                      setSelectedOrder(null);
                    }}
                    className="p-0 text-decoration-none text-primary"
                    style={{
                      fontSize: "18px",
                      fontWeight: "800",
                    }}
                  >
                    <i className="bx bx-arrow-back" /> Back to orders
                  </Button>
                </div>
                <hr
                  style={{
                    margin: "0",
                    borderColor: "#000",
                    marginBottom: "10px",
                  }}
                />

                {/* Order Header */}
                <div className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6
                      className="mb-0"
                      style={{ fontSize: "15px", fontWeight: "600" }}
                    >
                      {selectedOrder.orderId}
                    </h6>
                    <StatusBadge
                      status={selectedOrder.status}
                      type="order"
                      pill="true"
                    />
                  </div>
                  <div style={{ fontSize: "12px", color: "#6c757d" }}>
                    <div className="mb-1">
                      <i className="bx bx-user" style={{ fontSize: "13px" }} />{" "}
                      {customerInfo?.userName || "N/A"}
                    </div>
                    <div>
                      <i className="bx bx-phone" style={{ fontSize: "13px" }} />{" "}
                      {customerInfo?.user?.phoneNumber || "N/A"}
                    </div>
                  </div>
                </div>

                {/* Order Items */}
                <div className="mb-3">
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#6c757d",
                      marginBottom: "8px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Order Items
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    {(selectedOrder.items || []).map((item, idx) => (
                      <div
                        key={idx}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "10px 12px",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "6px",
                          border: "1px solid #e9ecef",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: "13px",
                              fontWeight: "500",
                              marginBottom: "2px",
                            }}
                          >
                            {item.name}
                          </div>
                          <div style={{ fontSize: "11px", color: "#6c757d" }}>
                            Rs. <NumberWithCommas number={item.price} /> ×{" "}
                            {item.qty}
                          </div>
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            fontWeight: "600",
                            color: "#ff7900",
                          }}
                        >
                          Rs.{" "}
                          <NumberWithCommas number={item.price * item.qty} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Total Amount */}
                <div
                  style={{
                    padding: "12px",
                    backgroundColor: "#fff8f0",
                    borderRadius: "6px",
                    border: "1px solid #ffe4cc",
                    marginBottom: "12px",
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#495057",
                      }}
                    >
                      Total Amount
                    </span>
                    <span
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#ff7900",
                      }}
                    >
                      Rs.{" "}
                      <NumberWithCommas number={selectedOrder.totalAmount} />
                    </span>
                  </div>
                </div>

                {/* Special Instructions */}
                {selectedOrder.specialInstructions && (
                  <div
                    style={{
                      padding: "10px 12px",
                      backgroundColor: "#f8f9fa",
                      borderRadius: "6px",
                      border: "1px solid #e9ecef",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#6c757d",
                        marginBottom: "4px",
                      }}
                    >
                      SPECIAL INSTRUCTIONS
                    </div>
                    <div style={{ fontSize: "12px", color: "#495057" }}>
                      {selectedOrder.specialInstructions}
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                <div
                  style={{
                    position: "sticky",
                    bottom: 0,
                    background: "white",
                    padding: "12px 0",
                    borderTop: "1px solid #e9ecef",
                    display: "flex",
                    gap: "8px",
                    marginTop: "auto",
                  }}
                >
                  {selectedOrder.status?.toLowerCase() === "ongoing" && (
                    <Button
                      color="danger"
                      style={{
                        flex: 1,
                        padding: "10px 0",
                        fontSize: "13px",
                        fontWeight: "600",
                        borderRadius: "6px",
                      }}
                      onClick={(e) => {
                        playBeep();
                        e.stopPropagation();
                        handleCancelClick(selectedOrder);
                      }}
                    >
                      Cancel Order
                    </Button>
                  )}
                  {selectedOrder.status?.toLowerCase() !== "cancelled" && selectedOrder.status?.toLowerCase() !== "completed" && (
                    <Button
                      color="success"
                      style={{
                        flex: 1,
                        padding: "10px 0",
                        fontSize: "13px",
                        fontWeight: "600",
                        borderRadius: "6px",
                      }}
                      onClick={() => {
                        playBeep();
                        navigate(`/${orgcode}/order-summary`, {
                          state: {
                            orgData,
                            orderResponse: selectedOrder,
                          },
                        });
                      }}
                    >
                      Confrim Order
                    </Button>
                  )}
                </div>
              </>
            </>
          )}
        </OffcanvasBody>
      </Offcanvas>

      <ConfirmModal
        show={cancelModalVisible}
        title="Cancel Order"
        message="Are you sure you want to cancel this order?"
        onConfirm={confirmCancelOrder}
        onCancel={() => setCancelModalVisible(false)}
        loading={loading}
      />
    </>
  );
};

export default OrderTracking;
